import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const KundensegmentServiceConfig = {
  name: "Kundensegment",
  annotations: []
} as ServiceConfig;